import { createSlice } from '@reduxjs/toolkit';
const columnsRenderSlice = createSlice({
  name: 'columnsRender',
  initialState: {
    columnsRender: {}
  },
  reducers: {
    setColumnsCollapsed: (state, action) => {
      const columnSettings = action.payload;
      columnSettings.forEach(({
        columnId,
        collapsed
      }) => {
        const columnRenderState = state.columnsRender[columnId];
        if (columnRenderState) {
          columnRenderState.collapsed = collapsed;
        } else {
          state.columnsRender[columnId] = {
            collapsed
          };
        }
      });
    }
  }
});
export const {
  setColumnsCollapsed
} = columnsRenderSlice.actions;
export { columnsRenderSlice };